import { useIntl } from 'react-intl'
import styled from 'styled-components'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import Tooltip from 'LuxKit/Tooltip'

const BookingConditionsList = styled.span`
  display: block;
  text-align: start;
  white-space: pre-line;
`

interface Props {
  conditions: Array<App.PackageInclusion>
}

function CruiseBookingConditionsInfo({ conditions }: Props) {
  const intl = useIntl()
  const description = conditions.map((condition) => `• ${condition.description}`).join('\n')
  const label = intl.formatMessage({
    id: 'vuLhdT_gMUlqGZo2OqT3',
    defaultMessage: 'Booking conditions',
    description: 'Accessible label for the tooltip listing cruise inclusion booking conditions',
  })

  return <Tooltip description={<BookingConditionsList>{description}</BookingConditionsList>} placement="bottom-start">
    <LineInfoCircleIcon aria-label={label} colour="light-foreground-alt" size={14} />
  </Tooltip>
}

export default CruiseBookingConditionsInfo
